import CourseStatusBannerContainer from './CourseStatusBannerContainer';
export default CourseStatusBannerContainer;
